import { gql } from "@apollo/client";

export const GET_DELEGACION_NH_SAP = gql`
query GetInstitucionDelegacionNHSAP ($codInstitucion: String!) {
    institucionDelegacionNHSAP(codInstitucion: $codInstitucion)
    {
        success,
        error,
        valorEsperado {
            codInstitucion,
            idDelegacion_NH,
            codDelegacion_NH,
            idDelegacion_SAP,
            codDelegacion_SAP,
            cod_Provincia,
            idProvincia,
            provincia,
            localidad,
            domicilio
        }
    }
}`;